module.exports = __webpack_public_path__ + "static/media/Illus-Diversity_1.4b8b1377.png";